import { opportunityConstants } from '../constants/actionTypes'
import * as opportunityService from '../services/opportunityService'
import { fetchConsultantSuccess } from './consultantActions'
import { fetchUserSuccess } from './userActions'
import { SetApplicationRole } from './applicationRoleActions'
import { applicationRoles } from '../constants/actionTypes'
import { OnProposalIDReceived } from '../actions/proposalsActions'
import { fetchIndividualEstimate } from './individualEstimateActions'
import { isDateValid } from '../helpers'

export const receiveOpportunityId = (opportunityId) => ({
  type: opportunityConstants.RECEIVE_OPPORTUNITY_ID,
  opportunityId,
})

const fetchOpportunityInfoRequest = () => ({
  type: opportunityConstants.FETCH_OPPORTUNITY_INFO_REQUEST,
})

const fetchOpportunityInfoSuccess = (opportunityInfo) => ({
  type: opportunityConstants.FETCH_OPPORTUNITY_INFO_SUCCESS,
  payload: opportunityInfo,
})

const fetchOpportunityInfoError = (errorMessage) => ({
  type: opportunityConstants.FETCH_OPPORTUNITY_INFO_ERROR,
  errorMessage,
})

export function fetchOpportunityInfo(opportunityId) {
  return (dispatch) => {
    dispatch(fetchOpportunityInfoRequest())

    return opportunityService.fetchOpportunityInfo(opportunityId).then(
      (opportunityInfo) => {
        opportunityInfo.id = opportunityId
        const {
          consultant,
          customer,
          parentOrganisationERCode,
          hasSpartaVehicle,
        } = opportunityInfo
        dispatch(fetchConsultantSuccess(consultant))
        dispatch(
          fetchUserSuccess({
            customer,
            parentOrganisationERCode,
            hasSpartaVehicle,
          })
        )

        dispatch(OnProposalIDReceived(opportunityInfo.proposal))
        if (
          opportunityInfo.proposal !== null &&
          opportunityInfo.proposal.quoteId !== null &&
          opportunityInfo.proposal.quoteId !== undefined &&
          opportunityInfo.proposal.quoteId !==
            '00000000-0000-0000-0000-000000000000'
        ) {
          dispatch(
            fetchIndividualEstimate(
              opportunityId,
              opportunityInfo.proposal.quoteId,
              true,
              false
            )
          )
        }

        dispatch(fetchOpportunityInfoSuccess(opportunityInfo))
        if (
          opportunityInfo.hasIndicativeProposal === true &&
          (opportunityInfo.proposal.proposalNumber === null ||
            opportunityInfo.proposal.proposalNumber === undefined ||
            opportunityInfo.proposal.isValid === false)
        ) {
          dispatch(SetApplicationRole(applicationRoles.USER_ACCEPTED_ESTIMATE))
        } else if (
          opportunityInfo.hasIndicativeProposal === true &&
          opportunityInfo.proposal.proposalNumber !== null &&
          opportunityInfo.proposal.proposalNumber !== undefined &&
          opportunityInfo.proposal.acceptedOn != null &&
          ((isDateValid(opportunityInfo.proposal.acceptedOn) &&
            !isDateValid(opportunityInfo.proposal.cancelledOn)) ||
            new Date(opportunityInfo.proposal.acceptedOn) >
              new Date(opportunityInfo.proposal.cancelledOn))
        ) {
          dispatch(
            SetApplicationRole(applicationRoles.USER_WITH_PROPOSAL_ACCEPTED)
          )
        } else if (
          opportunityInfo.hasIndicativeProposal === true &&
          opportunityInfo.proposal.proposalNumber !== null &&
          opportunityInfo.proposal.proposalNumber !== undefined &&
          opportunityInfo.proposal.isValid === true
        ) {
          dispatch(
            SetApplicationRole(applicationRoles.USER_WITH_PROPOSAL_SETUP)
          )
        } else {
          dispatch(SetApplicationRole(applicationRoles.USER_WITH_ESTIMATES))
        }
      },
      (error) => {
        dispatch(fetchOpportunityInfoError(error))
      }
    )
  }
}
